import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableRow, TableHead } from '@mui/material';
import PropTypes from 'prop-types';
import DocumentTemplateSignatureBookmarkOptionListItemComponent from './DocumentTemplateSignatureBookmarkOptionListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';

const DocumentTemplateSignatureBookmarkOptionListComponent = ({
  documentTemplate,
  validation,
  optionSources,
  onOptionBookmarkPropertyChanged,
  onLookupOptionBookmarkPropertyChanged,
  onOptionBookmarkDeleted
}) => {
  const [t] = useTranslation();

  return (
    <CardNoResultsWrapper content={documentTemplate?.documentTemplateXOptionBookmarks}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCellWithWidth w={15}>{t('DocumentTemplate.Name')}</TableCellWithWidth>
            <TableCellWithWidth w={25}>{t('DocumentTemplate.DataSource')}</TableCellWithWidth>
            <TableCellWithWidth w={40}>{t('DocumentTemplate.GeneratedBookmarks')}</TableCellWithWidth>
            <TableCellWithWidth w={10}>{t('RequiredDocument.Actions')}</TableCellWithWidth>
          </TableRow>
        </TableHead>
        <TableBody>
          {documentTemplate?.documentTemplateXOptionBookmarks.map((item, idx) => {
            return (
              <DocumentTemplateSignatureBookmarkOptionListItemComponent
                documentTemplateXoptionBookmark={item}
                optionSources={optionSources}
                index={idx}
                key={idx}
                validation={validation}
                onDelete={onOptionBookmarkDeleted(idx)}
                handlePropertyChanged={onOptionBookmarkPropertyChanged(idx)}
                handleLookupPropertyChanged={onLookupOptionBookmarkPropertyChanged(idx)}
              />
            );
          })}
        </TableBody>
      </Table>
    </CardNoResultsWrapper>
  );
};

DocumentTemplateSignatureBookmarkOptionListComponent.propTypes = {
  validation: PropTypes.object.isRequired,
  documentTemplate: PropTypes.object.isRequired,
  optionSources: PropTypes.array,
  onOptionBookmarkPropertyChanged: PropTypes.func.isRequired,
  onLookupOptionBookmarkPropertyChanged: PropTypes.func.isRequired,
  onOptionBookmarkDeleted: PropTypes.func.isRequired
};

export default DocumentTemplateSignatureBookmarkOptionListComponent;
